import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = {
  style: {"margin-bottom":"10px"},
  class: "grid ml-0 mr-1"
}
const _hoisted_3 = { class: "flex flex-auto p-input-icon-left p-input-icon-right mt-1" }
const _hoisted_4 = { class: "flex align-items-center" }
const _hoisted_5 = { class: "flex ml-4 mr-4" }
const _hoisted_6 = {
  key: 1,
  style: {"width":"100%","height":"calc(100vh - 260px)"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_InputSwitch = _resolveComponent("InputSwitch")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Message = _resolveComponent("Message")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Column = _resolveComponent("Column")!
  const _component_Badge = _resolveComponent("Badge")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[6] || (_cache[6] = _createElementVNode("i", { class: "pi pi-users" }, null, -1)),
        _createVNode(_component_InputText, {
          modelValue: _ctx.filterText,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filterText) = $event)),
          onInput: _ctx.filterChanged,
          placeholder: "Keyword filter.."
        }, null, 8, ["modelValue", "onInput"]),
        _cache[7] || (_cache[7] = _createElementVNode("i", { class: "pi pi-search" }, null, -1))
      ]),
      _createElementVNode("div", _hoisted_4, [
        _withDirectives(_createElementVNode("a", {
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.companyListExcelExport && _ctx.companyListExcelExport(...args))),
          class: "css-image excel-icon mt-1"
        }, null, 512), [
          [
            _directive_tooltip,
            'Export to Excel',
            void 0,
            { top: true }
          ]
        ]),
        _createElementVNode("div", _hoisted_5, [
          _withDirectives(_createElementVNode("a", {
            class: _normalizeClass(["css-image", _ctx.filterNorthIsland ? 'north-island-icon':'north-island-disabled-icon']),
            style: {"position":"absolute","margin-top":"-15px","height":"20px","width":"30px"},
            onClick: _cache[2] || (_cache[2] = ($event: any) => {_ctx.filterNorthIsland = !_ctx.filterNorthIsland;_ctx.filterSouthIsland = false;})
          }, null, 2), [
            [
              _directive_tooltip,
              'Show companies operating in North Island',
              void 0,
              { top: true }
            ]
          ]),
          _withDirectives(_createElementVNode("a", {
            class: _normalizeClass(["css-image", _ctx.filterSouthIsland ? 'south-island-icon':'south-island-disabled-icon']),
            style: {"position":"absolute","margin-top":"5px","height":"20px","width":"30px"},
            onClick: _cache[3] || (_cache[3] = ($event: any) => {_ctx.filterSouthIsland = !_ctx.filterSouthIsland;_ctx.filterNorthIsland = false;})
          }, null, 2), [
            [
              _directive_tooltip,
              'Show companies operating in South Island',
              void 0,
              { top: true }
            ]
          ])
        ]),
        _createVNode(_component_InputSwitch, {
          modelValue: _ctx.onlyActive,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.onlyActive) = $event)),
          class: "ml-4 mr-1 mt-1"
        }, null, 8, ["modelValue"]),
        _createElementVNode("a", {
          class: "mr-4 mt-1",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onlyActive=!_ctx.onlyActive))
        }, "Only active"),
        _createVNode(_component_Button, {
          icon: "pi pi-plus",
          label: "New",
          onClick: _ctx.newCompany,
          class: "p-button-rounded mt-1"
        }, null, 8, ["onClick"])
      ])
    ]),
    (_ctx.companyList.errorMessage)
      ? (_openBlock(), _createBlock(_component_Message, {
          key: 0,
          severity: "error",
          style: {"white-space":"pre-wrap"}
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.companyList.errorMessage), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.companyList.hasReceivedData)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createVNode(_component_DataTable, {
            value: _ctx.filteredCompanyList,
            datakey: "id",
            paginator: true,
            rows: 100,
            scrollable: true,
            scrollHeight: "flex",
            rowClass: _ctx.applyRowClass,
            stripedRows: "",
            class: "p-datatable-sm",
            paginatorTemplate: _ctx.paginatorTemplate,
            rowsPerPageOptions: [10,20,50,100,200],
            responsiveLayout: "scroll",
            currentPageReportTemplate: "Showing {first} to {last} of {totalRecords}"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Column, {
                field: "id",
                header: "ID",
                style: {"flex-grow":"0","flex-basis":"70px"}
              }, {
                body: _withCtx(({data}) => [
                  _createVNode(_component_router_link, {
                    to: { name: 'CompanyDetails', params: { companyId: data.id }}
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(data.id), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ]),
                _: 1
              }),
              _createVNode(_component_Column, {
                field: "name",
                header: "Name",
                style: {"flex-basis":"300px"}
              }, {
                body: _withCtx(({data}) => [
                  _createVNode(_component_router_link, {
                    to: { name: 'CompanyDetails', params: { companyId: data.id }}
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(data.name), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"]),
                  (!_ctx.isActive(data))
                    ? (_openBlock(), _createBlock(_component_Badge, {
                        key: 0,
                        class: "small-grey-badge ml-1",
                        value: "inactive"
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, {
                field: "loc",
                header: "Location",
                class: "hidden md:flex",
                style: {"flex-basis":"100px"}
              }, {
                body: _withCtx(({data}) => [
                  _createVNode(_component_router_link, {
                    to: { name: 'CompanyDetails', params: { companyId: data.id }}
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(data.loc), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"]),
                  (data.isle == 'NI SI')
                    ? _withDirectives((_openBlock(), _createBlock(_component_Badge, {
                        key: 0,
                        class: "css-image new-zealand-icon island-badge ml-1"
                      }, null, 512)), [
                        [
                          _directive_tooltip,
                          'Operates in North & South Island',
                          void 0,
                          { top: true }
                        ]
                      ])
                    : (data.isle == 'NI')
                      ? _withDirectives((_openBlock(), _createBlock(_component_Badge, {
                          key: 1,
                          class: "css-image north-island-icon island-badge ml-1"
                        }, null, 512)), [
                          [
                            _directive_tooltip,
                            'Operates in North Island',
                            void 0,
                            { top: true }
                          ]
                        ])
                      : (data.isle == 'SI')
                        ? _withDirectives((_openBlock(), _createBlock(_component_Badge, {
                            key: 2,
                            class: "css-image south-island-icon island-badge ml-1"
                          }, null, 512)), [
                            [
                              _directive_tooltip,
                              'Operates in South Island',
                              void 0,
                              { top: true }
                            ]
                          ])
                        : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, {
                field: "conts",
                header: "Contacts",
                class: "hidden md:flex",
                style: {"flex-basis":"300px"}
              }, {
                body: _withCtx(({data}) => [
                  _createVNode(_component_router_link, {
                    to: { name: 'CompanyDetails', params: { companyId: data.id }}
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(data.conts), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ]),
                _: 1
              }),
              _createVNode(_component_Column, {
                class: "hidden md:flex",
                header: "Properties",
                style: {"flex-basis":"50px"}
              }, {
                body: _withCtx(({data}) => [
                  _createVNode(_component_router_link, {
                    to: { name: 'CompanyDetails', params: { companyId: data.id }}
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(data.np), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["value", "rowClass", "paginatorTemplate"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_ProgressSpinner, { key: 2 }))
      : _createCommentVNode("", true)
  ]))
}